import React, { useState, useEffect, useRef } from "react";
import PageWrapper from "./components/PageWrapper";
import { useFormCtx } from "./FormContext";
import Button from "./components/Button";
import TransitionBlock from "./components/TransitionBlock";
import * as Const from "./_Const";
import useScreenType from "./hooks/useScreenType";
import useTimeout from "./hooks/useTimeout";

const PAGE_ID_TOP_NESTED = 6;
const PAGE_ID_DOCTORS = 4;
const PAGE_ID_BUTTONS = 1;

function PageButtons() {
  const screenType = useScreenType();
  const [number, setNumber] = useState(1);
  const [showExitText, setShowExitText] = useState(false);
  const [exitText, setExitText] = useState(null);
  const [exitTextInterval, setExitTextInterval] = useState(0);

  const { set: setTimer, clear: clearTimer, reset: resetTimer } = useTimeout(() => navigateAfterQueueChangeTimeout(), Const.QUEUE_CHANGE_INTERVAL);
  const { currentBtnPageIndex, navigateNextButtons, selectedButtonId, getApiPage, getButtonsData, beep } = useFormCtx();
  const isTerminal = Const.isTerminal();
  const index = isTerminal ? Const.REG_RPI_REASON_BUTTON_INDEX : Const.REG_01_INDEX;
  let exitTextIntervalRef = useRef(null);

  //const page = getPageData(index);

  const buttonsData = getButtonsData();
  const noNestingData = getButtonsFilter(PAGE_ID_BUTTONS);
  const firstNestingData = getButtonsFilter(PAGE_ID_DOCTORS);
  const secondNestingData = getButtonsFilter(PAGE_ID_TOP_NESTED);

  //pro testovani zadat getTestData()
  let data = getData(); //getTestData(); //getData();

  //Vyčištění při odchodu z komponenty (unmount)
  useEffect(() => {
    return () => {
      if (exitTextIntervalRef.current) clearTimeout(exitTextIntervalRef.current);
    };
  }, []);

  //po zmene dat pro danou stranku nastav spravny defaultQueueInterval a pageExitTextInterval z pageData
  useEffect(() => {
    function scopedLoadData() {
      if (isTerminal) {
        const interval = data?.defaultQueueInterval === 0 ? Const.QUEUE_CHANGE_INTERVAL : data?.defaultQueueInterval * 1000;
        console.log(`${new Date().toISOString()} PageButtons scopedLoadData setting QUEUE_CHANGE_INTERVAL to ${interval}`);

        const localExitTextInterval = data?.pageExitTextInterval === 0 ? Const.EXIT_TEXT_INTERVAL : data?.pageExitTextInterval * 1000;
        console.log(`${new Date().toISOString()} PageButtons scopedLoadData setting EXIT_TEXT_INTERVAL to ${localExitTextInterval}`);

        setExitTextInterval(localExitTextInterval);
        setTimer(interval);
      }
    }
    scopedLoadData();
  }, [data]);

  function navigateAfterQueueChangeTimeout() {
    if (isTerminal) {
      //u PAGE_ID_DOCTORS a PAGE_ID_TOP_NESTED je defaultQueueId id tlacitka
      //u PAGE_ID_BUTTONS je defaultQueueId queueId
      const defaultQueueId = data?.defaultQueueId;
      let defaultItem = null;

      switch (data?.pageId) {
        case PAGE_ID_BUTTONS:
          defaultItem = data?.buttons.find((item) => item.queueId === defaultQueueId);
          break;
        case PAGE_ID_DOCTORS:
        case PAGE_ID_TOP_NESTED:
          defaultItem = data?.buttons.find((item) => item.id === defaultQueueId);
          break;
      }
      console.log(`${new Date().toISOString()} navigateAfterQueueChangeTimeout expiration: defaultQueueId: ${defaultQueueId}, defaultItem:`, defaultItem);

      //simulace vybrani default talcitka
      if (defaultItem) {
        beep();
        handleButtonClick(defaultItem, index, true);
      }
    }
  }

  function getButtonsFilter(page) {
    return buttonsData ? buttonsData.filter((item) => item.pageId === page) : null;
  }

  function getButtonsFind(data, id) {
    return data ? data.find((item) => item.doctorId === id) : null;
  }

  function getData() {
    let data = null;
    if (secondNestingData && secondNestingData.length > 0) {
      log("6 exists");
      if (currentBtnPageIndex == 0) {
        data = secondNestingData;
      } else if (currentBtnPageIndex == 1) {
        data = getButtonsFind(firstNestingData, selectedButtonId);
      } else if (currentBtnPageIndex == 2) {
        data = getButtonsFind(noNestingData, selectedButtonId);
      }
    } else {
      log("6 not exists");
      if (firstNestingData && firstNestingData.length > 0) {
        log("4 exists");
        if (currentBtnPageIndex == 0) {
          data = firstNestingData;
        } else if (currentBtnPageIndex == 1) {
          data = getButtonsFind(noNestingData, selectedButtonId);
        }
      } else {
        log("4 not exists");
        if (noNestingData && noNestingData.length > 0) {
          log("1 exists");
          if (currentBtnPageIndex == 0) {
            data = noNestingData;
          }
        } else {
          log("1 not exists");
        }
      }
    }

    if (data && data.length === 1) {
      data = data[0];
    }
    //console.log(data);
    return data;
  }

  function log(text) {
    // console.log(text);
  }

  function getTestData() {
    const source = {
      title: "Důvod návštěvy",
      subtitle: "Zvolte důvod návštěvy",
      buttons: [
        {
          id: 1,
          order: 1,
          queueId: 1005,
          text: "Vyšetření",
          /*text: "Administrativan\nVýpis z dok.\nLístek na peníze",*/
        },
        {
          id: 2,
          order: 2,
          queueId: 1044,
          text: "Recept",
        },
        {
          id: 3,
          order: 3,
          queueId: 1043,
          text: "Kontrola",
        },
        {
          id: 4,
          order: 4,
          queueId: 1045,
          text: "Administrativa",
        },
        {
          id: 5,
          order: 5,
          queueId: 1046,
          text: "Ostatní",
        },
        {
          id: 6,
          order: 6,
          queueId: 1047,
          text: "Produktivita",
        },
        {
          id: 7,
          order: 7,
          queueId: 1048,
          text: "Injekce",
        },
        {
          id: 8,
          order: 8,
          queueId: 1049,
          text: "Lístek na peníze",
        },

        {
          id: 9,
          order: 9,
          queueId: 1050,
          text: "Jsem objednán(a)",
        },
        {
          id: 10,
          order: 10,
          queueId: 1051,
          text: "Recepty, Kontrola krev. tlaku",
        },
      ],
    };

    console.log(number);

    const filtered = source.buttons.filter((i, index) => index < number);

    return { ...source, buttons: filtered };
  }

  //console.log(data);

  const showTitleOnNavbar = isTerminal;
  let showSubtitle = data?.buttons?.length >= 8 ? false : true;
  if (isTerminal) {
    showSubtitle = false; // v terminalu bude subtitle v ramci navbar a ne jako h1 stranky
  } else {
  }

  //const text = "Přednostní vyšetření text a";
  function canWrapTitle(title) {
    let canWrap = false;

    const len = title?.length ?? 0;
    // console.log(len);

    if (len > 25) {
      canWrap = true;
    }
    // console.log(title, len, canWrap);
    return canWrap;
  }

  //pro testovani vice tlacitek
  function handleTestButtonsClick(params) {
    if (number === 10) {
      setNumber(1);
    } else {
      setNumber(number + 1);
    }
  }

  function handleButtonClick(item, index, isSetWithoutTouch = false) {
    let showExitTextNow = false;
    const localExitText = item?.exitText;
    if (localExitText) {
      setExitText(localExitText);
      showExitTextNow = true;
      setShowExitText(true);
    }

    if (isTerminal) {
      //nebudeli se zobrazovat exit text nastav resetTimer
      if (!showExitTextNow) {
        resetTimer();
      }
    }
    if (showExitTextNow) {
      console.log(`handleButtonClick start showing of exitText: ${localExitText} - timeout set to ${exitTextInterval}`);
      //poznamenani reference pro pozdejsi clear v unmount
      exitTextIntervalRef = setTimeout(() => {
        setShowExitText(false);
        navigateNextButtons(item, index, isSetWithoutTouch);
      }, exitTextInterval);
    } else {
      navigateNextButtons(item, index, isSetWithoutTouch);
    }
  }

  function handleBackButtonClick() {
    if (isTerminal) {
      resetTimer();
    }
  }

  function getFormatClass() {
    const count = data?.buttons?.length ?? 0;
    // console.log(count);

    let className = "flex flex-col space-y-4";
    let marginCss = "";
    let framerCss = "";
    let buttonCss;
    let showInfo = true;
    if (Const.isTerminal()) {
      switch (count) {
        case 2:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[160px]";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[255px]";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[295px]";
          }
          break;
        case 3:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px]";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px]";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh]";
          }
          break;
        case 4:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[72px]";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px]";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px]";
          }
          break;
        case 5:
          framerCss = "first:col-span-2";
          className = "grid grid-cols-2 gap-4 self-center items-center";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px]";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px]";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh]";
          }

          break;
        case 6:
          className = "grid grid-cols-2 gap-4 self-center items-center";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[101px]";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[165px]";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[24vh]";
          }
          break;
        case 7:
          framerCss = "first:col-span-2";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[75px]";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          break;
        case 8:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-5";
            buttonCss = "h-[75px]";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-8";
            buttonCss = "h-[120px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[140px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          break;
        case 9:
          framerCss = "first:col-span-2";

          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-[18px]";
            buttonCss = "h-[65px]";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-7";
            buttonCss = "h-[100px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[116px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          showInfo = false;
          break;
        case 10:
          if (screenType === Const.SCREEN_RPIV1) {
            marginCss = "mt-[18px]";
            buttonCss = "h-[65px]";
            className = "grid grid-cols-2 gap-3 self-center items-center";
          } else if (screenType === Const.SCREEN_RPIV2) {
            marginCss = "mt-7";
            buttonCss = "h-[100px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          } else {
            marginCss = "mt-8";
            buttonCss = "h-[116px]";
            className = "grid grid-cols-2 gap-4 self-center items-center";
          }
          showInfo = false;
          break;
      }
    } else {
      //na terminalu nepoustet PING jen na mobilu - je to hodne vytezujici procesor 20-30% i teplotu
      buttonCss = "ping";
    }
    return { css: className, buttonCss, framerCss, showInfo, marginCss };
  }
  const { css, buttonCss, framerCss, showInfo, marginCss } = getFormatClass();

  const delay = isTerminal ? 0 : 0.01;

  if (screenType === Const.SCREEN_UNKNOWN) {
    return;
  }

  //console.log("xx", exitText);

  function getCustonStyle(item) {
    return (item?.fontSize ?? 0 > 0) ? { fontSize: `${item?.fontSize}px` } : null;
  }

  function getApiButtonsCss(item) {
    let css = "";
    if (item) {
      //console.log("xxx", item);
      const aligment = item?.alignment ?? 0;

      let aligmentCss = "";
      switch (aligment) {
        case Const.BUTTON_ALIGNMENT_CENTER:
          aligmentCss = "text-center";
          break;
        case Const.BUTTON_ALIGNMENT_LEFT:
          aligmentCss = "text-left";
          break;
        case Const.BUTTON_ALIGNMENT_RIGHT:
          aligmentCss = "text-right";
          break;
      }

      // function setSize(size, defaultVal) {
      //   return size > 0 ? `text-[${size}px]` : defaultVal;
      // }

      // const size = item?.fontSize ?? 0;
      const count = data?.buttons?.length ?? 0;
      let buttonCss = "";
      switch (count) {
        case 2:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-4xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-6xl";
          } else {
            buttonCss = "text-6xl";
          }
          break;
        case 3:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-4xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-5xl";
          } else {
            buttonCss = "text-5xl";
          }
          break;
        case 4:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-4xl";
          } else {
            buttonCss = "text-4xl";
          }
          break;
        case 5:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-4xl";
          } else {
            buttonCss = "text-4xl";
          }

          break;
        case 6:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-4xl";
          } else {
            buttonCss = "text-4xl";
          }
          break;
        case 7:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-4xl";
          } else {
            buttonCss = "text-4xl";
          }
          break;
        case 8:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-2xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-3xl";
          } else {
            buttonCss = "text-3xl";
          }
          break;
        case 9:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-3xl";
          } else {
            buttonCss = "text-3xl";
          }
          break;
        case 10:
          if (screenType === Const.SCREEN_RPIV1) {
            buttonCss = "text-xl";
          } else if (screenType === Const.SCREEN_RPIV2) {
            buttonCss = "text-3xl";
          } else {
            buttonCss = "text-3xl";
          }
          break;
      }

      css = `${aligmentCss} ${buttonCss}`;
    }
    return css;
  }

  function getApiTextTransformButtonCss(item) {
    let css = "";
    if (item) {
      const allCapsDisabled = item?.allCapsDisabled ?? false;
      css = allCapsDisabled ? "" : "uppercase";
    }
    return css;
  }

  return (
    <>
      {showExitText && (
        <div className="text-error-dark mx-4 scWaveShare:mx-8 text-5xl scRPIV2:text-6xl scWaveShare:text-7xl text-center grid h-screen place-items-center">
          <h1>{exitText}</h1>
        </div>
      )}
      {!showExitText && data && (
        <PageWrapper title={data.title} onBackClick={handleBackButtonClick} subtitle={data.subtitle} index={index} showTitleOnNavbar={showTitleOnNavbar}>
          {showSubtitle && <h2 className="mt-6 text-xl font-light text-primary">{data.subtitle}</h2>}
          <div className={`mt-2 mx-4 scRPIV2:mt-4 scRPIV2:mx-6 scWaveShare:mt-4 scWaveShare:mx-6  ${css} ${marginCss}`}>
            {data &&
              data.buttons &&
              data.buttons.map((item, aIndex) => (
                <TransitionBlock key={item.id} delay={delay * aIndex} className={`${framerCss}`}>
                  <Button
                    className={`w-full ${buttonCss} ${getApiButtonsCss(item)}`}
                    key={item.id}
                    title={item.text}
                    canWrap={canWrapTitle(item.text)}
                    showIcon={item.queueId == 0}
                    textTransformCss={getApiTextTransformButtonCss(item)}
                    customButtonStyle={getCustonStyle(item)}
                    // onClick={handleTestButtonsClick}
                    onClick={() => handleButtonClick(item, index)}
                  />
                </TransitionBlock>
              ))}
          </div>

          {showInfo && (
            <p className="text-sm mt-4 mx-4 scRPIV2:text-lg scRPIV2:mt-3 scRPIV2:mx-6 scWaveShare:text-lg scWaveShare:mt-3 scWaveShare:mx-6 text-secondary font-light">
              Kliknutím na jedno z tlačítek přejdete na další obrazovku
            </p>
          )}
        </PageWrapper>
      )}
    </>
  );
}

export default PageButtons;
